import type { Component } from 'solid-js'
import { DEFAULT_ICON_SIZE, type IconProps } from './icon'

const CheckCircle: Component<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class={`w-${props.size ?? DEFAULT_ICON_SIZE} h-${props.size ?? DEFAULT_ICON_SIZE}`}>
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  )
}

export default CheckCircle
